export default __webpack_public_path__ + "static/media/milton2.8645f0d8.png";